import type { FC } from "react";
import Head from "next/head";
import { serializeJsonLd, type JsonLdNode } from "./serialize";

interface StructuredDataProps {
  /** Узлы графа schema.org; пустой список ничего не рендерит */
  nodes: (JsonLdNode | null | undefined)[];
}

/**
 * JSON-LD страницы одним графом (@graph) в <head>. Ключ у script один на
 * приложение: страница под route-диалогом и сам диалог рендерят каждый
 * свою разметку, next/head оставляет последнюю, то есть разметку экрана,
 * который зритель видит. Сборка узлов в builders.ts, только из данных
 * запросов страницы.
 */
export const StructuredData: FC<StructuredDataProps> = ({ nodes }) => {
  const graph = nodes.filter((node): node is JsonLdNode => Boolean(node));
  if (graph.length === 0) return null;

  return (
    <Head>
      <script
        type="application/ld+json"
        key="structured-data"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(graph) }}
      />
    </Head>
  );
};
